import React from "react";
import {Col, Row, Spinner} from "react-bootstrap";
import {Route, Routes} from "react-router-dom";
import {DASHBOARD, EXPLORER} from "../../../services/PageUtils";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import {SessionState} from "../../../services/store/reducers/session/slice";
import Dashboard from "../../dashboard/pages/Dashboard";
import PlatformNavBar from "../../../components/navbar/PlatformNavBar";
import Explorer from "../../explorer/pages/Explorer";

interface Props {
    logOut: () => void
}

const PlatformApp = ({logOut}: Props) => {

    const {sessionState} = handicaddieSelector(state => state.session)

    return (
        <>
            {(sessionState !== SessionState.ACTIVE) &&
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '3em',
                    textAlign: 'center'
                }}>
                    <Row>
                        <Col>
                            <Spinner animation="border" variant="primary"/>
                            <h5>Loading...</h5>
                        </Col>
                    </Row>
                </div>
            }

            {(sessionState === SessionState.ACTIVE) && <>
                <PlatformNavBar logOut={logOut} isLocked={false}/>
                <Routes>
                    <Route path={DASHBOARD} element={<Dashboard />}/>
                    <Route path={EXPLORER} element={<Explorer />}/>
                    <Route index element={<Dashboard/>}/>
                </Routes>
            </>}
        </>
    )

}

export default PlatformApp;